<template>
    <tr class="main-content" :class="{'is-visited': isVisited, 'has-bid': hasBid }">
        <td class="picture-td" data-label="photo">
            <figure class="image is-65x65" @click="openGallery">
                <img :src="lot.pictures.split('#')[1] + '&w=320'">
            </figure>
        </td>
        <td class="link" @click="goToLotSinglePage" data-label="Date/Time">
            {{ lot.lot_date.split(' ')[0] }}<br>
            {{ lot.lot_date.split(' ')[1] }}
        </td>
        <td class="link" @click="goToLotSinglePage" data-label="Place/Lot #">
            {{ lot.auction_name }}<br>
            {{ lot.bid }}
        </td>
        <td @click="goToLotSinglePage" data-label="Model/Grade">
            {{ lot.company }} {{ lot.model_name_en }}<br>
            <span v-html="lot.grade_en"></span>
        </td>
        <td @click="goToLotSinglePage" data-label="Year">
            {{ lot.model_year_en }}
        </td>
        <td @click="goToLotSinglePage" data-label="Chassis/Engine">
            <span v-html="lot.model_type_en"></span><br>
            {{ lot.displacement_num }} cc
        </td>
        <td @click="goToLotSinglePage" data-label="Mileage/TM">
            {{ lot.mileage_num * 1000 | formatNumber }} km<br>
            {{ lot.transmission_en }}
        </td>
        <td @click="goToLotSinglePage" data-label="Color/Score">
            {{ lot.color_en }}<br>
            {{ lot.scores }}
        </td>
        <td @click="openStatisticsModal" class="link tooltip" data-tooltip="Market Price research" data-label="Market Price">
            <button class="button is-danger is-small is-outlined">
                <span class="icon is-small">
                    <i class="fas fa-chart-bar"></i>
                </span>
                <span>MARKET PRICE</span>
            </button>
        </td>
        <td data-label="Start Price">
            <span>{{ lot.start_price * 1000 | formatNumber }}</span><br>
            {{ timeSince(new Date(lot.lot_date)) }}
        </td>
        <td @click="goToLotSinglePage" data-label="Result Price">
            {{ lot.result }}<br>
            <span class="result_price">¥{{ lot.end_price * 1000 | formatNumber }}</span>
        </td>
        <td v-if="bidIsOpen(lot.lot_date)" data-label="Bid">
            <div class="display-flex">
            <button v-if="lot.bids.length > 0" class="button is-small is-info is-outlined place-bid-auction" @click="openBidModal">
                <img src="/static/images/icons/update-bid.png" class="update-bid-icon fontawesome-icon">
                <span>{{ lot.bids[0].amount_yen * 1000 | formatNumber }}</span>
            </button>
            <button class="button is-small is-premium place-bid-auction" v-else @click="openBidModal">
                <img src="/static/images/icons/update-bid.png" class="update-bid-icon fontawesome-icon">
                <span>place bid</span>
            </button>
            <favorite-delete v-if="((this.lot.favorite.length > 0 === true))" :bid="lot"></favorite-delete>
            <favorite-create v-else :bid="lot"></favorite-create>
            </div>
        </td>
        <td v-else data-label="Bid">
            All bids closed
            <favorite-delete v-if="((this.lot.favorite.length > 0 === true))" :bid="lot"></favorite-delete>
            <favorite-create v-else :bid="lot"></favorite-create>
        </td>
    </tr>
</template>

<script>
    import favoriteCreate from './../../../Card/Buttons/Lots/FavoriteCreate.vue'
    import favoriteDelete from './../../../Card/Buttons/Lots/FavoriteDelete.vue'
    export default {
        components: {
            favoriteCreate,
            favoriteDelete
        },
        props:['lot', 'index'],
        methods: {
            openStatisticsModal() {
                this.$store.dispatch('changeMarketPriceModalSelectedLot', this.lot)
                this.$store.dispatch('changeMarketPriceModalStatus', { status: true, lotId: this.lot.lot_id })
                this.$store.dispatch('fetchMarketPriceModalLots')
            },
            goToLotSinglePage() {
                this.$store.dispatch('setLotToIsVisited', this.lot.lot_id)
                this.$router.push({
                    path: '/single/' + this.lot.lot_id,
                })
            },
            openBidModal() {
                this.$store.dispatch('changeResultBiddingModalStatus', { status: true, lot: this.lot })
                this.$store.dispatch('fetchGroups', {date: this.lot.date})
                this.$store.dispatch('fetchGroupSettings')
                this.$store.dispatch('changeSearchResultActiveLotKey', this.index)
            },
            openGallery() {
                this.$store.dispatch('setResultGalleryItems', this.lot.pictures.split('#'))
                this.$store.dispatch('setResultGalleryOptions', { index: 0 })
                this.$store.dispatch('setResultGalleryStatus', true)
            },
            bidIsOpen(lot_date){
                return true
            },
            timeSince(date){
                var seconds = Math.floor((new Date() - date) / 1000);

                var interval = Math.floor(seconds / 31536000);

                if (interval > 1) {
                    return interval + " years ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " years";
                }
                interval = Math.floor(seconds / 2592000);
                if (interval > 1) {
                    return interval + " months ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " months";
                }
                interval = Math.floor(seconds / 86400);
                if (interval > 1) {
                    return interval + " days ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " days";
                }
                interval = Math.floor(seconds / 3600);
                if (interval > 1) {
                    return interval + " hours ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " hours";
                }
                interval = Math.floor(seconds / 60);
                if (interval > 1) {
                    return interval + " minutes ago";
                }else if (interval < -1){
                    return Math.abs(interval) + " minutes";
                }
                return Math.floor(seconds) + " seconds";
            }
        },
        computed: {
            isVisited() {
                return this.$store.getters.checkIfLotIsVisited(this.lot.lot_id)
            },
            hasBid() {
                return this.lot.bids.length > 0
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }
    .picture-td {
        width: 65px;
    }
    .link {
        cursor: pointer;
    }
    .image {
        cursor: pointer;
    }
    .is-visited {
        background: #a9ddff!important;
    }
    .has-bid {
        background: #f8dcff !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Result/AdvanceResultTableRow.vue